import styled from "styled-components";

export const Item = styled.div`
  width: 328px;
  height: ${(props) => props.h || 65}px;
  background-color: #fff;
  border-radius: 15px;
  padding-left: 15px;
  margin: 10px 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: ${(props) => props.fs || 16}px;

  &:last-child {
    margin-bottom: 16px;
  }

  &.q-item{
    justify-content: center;
    color: purple;
    background-color: #f5f5f5;
    cursor: pointer;
    margin: 0;
    margin-bottom: 12px;
    padding: 0;

    &.active{
      background-color: rgba(147, 112, 219, .3);
    }
  }
`;